var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageHitDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.198mm",
    height: "16.598mm",
    viewBox: "0 0 17.198 16.598",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.12e-8 -280.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.20391 0 0 -.20391 7.8791 291.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.883-0.98 2.158-1.471 3.53-1.471 1.275 0 2.55 0.491 3.531 1.471l19.516 20.006c1.863 1.962 1.863 5.002-0.098 6.964-1.961 1.863-5.002 1.863-6.963-0.099l-11.082-11.474v35.599c0 2.746-2.158 4.903-4.904 4.903-2.745 0-4.903-2.157-4.903-4.903v-35.599l-11.18 11.376c-1.864 1.961-5.002 1.961-6.963 0.098-1.962-1.863-1.962-5.002-0.098-6.963zm45.701 4.119v-24.714c0-2.746-2.158-4.903-4.904-4.903h-74.533c-2.746 0-4.904 2.157-4.904 4.903v24.714c0 2.746 2.158 4.903 4.904 4.903s4.903-2.157 4.903-4.903v-19.81h64.727v19.81c0 2.746 2.157 4.903 4.903 4.903s4.904-2.157 4.904-4.903"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHitDownload);
export default __webpack_public_path__ + "static/media/image_HitDownload.99d48a4163c4d48eec0eaa5fb9b9b06a.svg";
export { ForwardRef as ReactComponent };